import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { PayrollSchema } from "../schemas/payroll.schema";

const c = initContract();

export const payrollContract = c.router(
    {
        getPayrolls: {
            method: "GET",
            path: "/:entityId",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            responses: {
                200: z.array(PayrollSchema),
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/payroll",
    },
);
